import React from 'react';
import { CHECKOUT_URL, CTA_LABEL, pricing } from '../data/sushiContent';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  /** 'scroll' sends the reader to the offer section, 'checkout' goes straight to payment. */
  target?: 'scroll' | 'checkout';
  size?: 'md' | 'lg';
  className?: string;
  label?: string;
};
export function CtaButton({
  target = 'checkout',
  size = 'lg',
  className = '',
  label = CTA_LABEL
}: CtaButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-8 py-4 text-[13px] sm:text-sm' : 'px-6 py-3.5 text-[12px] sm:text-[13px]';
  const isCheckout = target === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : '#offer'} onClick={isCheckout ? () => trackPixelEvent('InitiateCheckout', {
    content_name: 'SUSHI FACIL EN CASA',
    value: Number(pricing.today.replace(/[^0-9.]/g, '')),
    currency: 'USD'
  }) : undefined} className={`inline-flex w-full max-w-md items-center justify-center rounded-full bg-champagne text-center font-sans font-semibold uppercase tracking-[0.14em] text-charcoal-950 shadow-lift transition-[background-color,transform] duration-150 ease-out hover:-translate-y-0.5 hover:bg-champagne-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-champagne active:translate-y-0 ${sizeClasses} ${className}`} data-id="element-69" data-mp="10cg585mfp34c">
      {label}
    </a>;
}